module.exports = __webpack_public_path__ + "static/mama-lynch-b868361cf5152f6e3dfc6b83b1dc6dad.jpg";